module.exports = __webpack_public_path__ + "media/images/icons/country_flags/br-d0cbca18e87d6514772b3d4bc2d4ff6c.svg";